
import { Inject, Injectable, DOCUMENT } from '@angular/core';

const GTM_ID_PATTERN = /^GTM-[A-Z0-9]{4,12}$/i;

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private initializedId = '';

  constructor(@Inject(DOCUMENT) private document: Document) {}

  initialize(googleTagManagerId: string): void {
    const id = (googleTagManagerId || '').trim().toUpperCase();
    if (!GTM_ID_PATTERN.test(id) || this.initializedId) {
      return;
    }

    const win = this.document.defaultView as Window & {
      dataLayer?: Array<Record<string, unknown>>;
    };
    win.dataLayer = win.dataLayer || [];
    win.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

    const script = this.document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`;
    script.dataset['whitelabelAnalytics'] = id;
    this.document.head.appendChild(script);
    this.initializedId = id;
  }
}
